module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-dokument-0654db4b6fc1e5866419e150fd7eb8ea.svg";